import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { AnnualPlanEndpoint } from './annualplanendpoint.service';

import { DepartmentDto } from '../models/Department.model';
import { ExternalDocumentDto } from '../models/ExternalDocument.model';
import { FileUploadDto } from '../models/FileUpload.model';
import { BusinessRuleMessage } from '../models/BusinessRuleMessage.model';
import { PrioritySubmissionDto } from '../models/PrioritySubmission.model';
import { PrioritySubmissionItemTypeVldDto } from '../models/PrioritySubmissionItemTypeVld.model';
import { IndustryPanelVldDto } from '../models/IndustryPanelVld.model';
import { SubmissionStatusVldDto } from '../models/SubmissionStatusVld.model';
import { PrioritySubmissionThemesVldDto } from '../models/PrioritySubmissionThemesVld.model';
import { PrioritySubmissionThemeAssociationDto } from '../models/PrioritySubmissionThemeAssociations.model';
import { OrganizationDto } from '../models/Organization.model';
import { RtrApplicableVldDto } from '../models/RtrApplicableVld.model';

import { AnnualPlanItemDto } from '../models/annualplanitem.model';
import { AnnualPlanIndustryPanelAssociationDto } from '../models/AnnualPlanIndustryPanelAssociation.model';
import { AnnualPlanItemStandAloneLegislationSessionAssociationDto } from '../models/AnnualPlanItemStandAloneLegislationSessionAssociation.model';
import { AnnualPlanItemStatusVldDto } from '../models/AnnualPlanItemStatusVld.model';
import { AnnualPlanOrganizationAssociationDto } from '../models/AnnualPlanOrganizationAssociation.model';
import { AnnualPlanRegulatoryItemTypeAssociationDto } from '../models/AnnualPlanRegulatoryItemTypeAssociation.model';
import { AnnualPlanRtrOmnibusBillSessionAssociationDto } from '../models/AnnualPlanRtrOmnibusBillSessionAssociation.model';
import { AnnualPlanThemeAssociationDto } from '../models/AnnualPlanThemeAssociation.model';
import { AnnualPlanYearVldDto } from '../models/AnnualPlanYearVld.model';
import { AnnualPlanScheduledContinuingVldDto } from '../models/AnnualPlanScheduledContinuingVld.model';
import { SessionVldDto } from '../models/SessionVld.model';


@Injectable()

export class AnnualPlanService {
  constructor(private router: Router, private annualPlanEndpoint: AnnualPlanEndpoint) {
  }

  getOrganizations(userProfileID?: string) {

    return this.annualPlanEndpoint.getOrganizations<OrganizationDto[]>(userProfileID);
  }

  getRtrApplicables(userProfileID?: string) {

    return this.annualPlanEndpoint.getRtrApplicables<RtrApplicableVldDto[]>(userProfileID);

  }

  getDepartments(userProfileID?: string) {

    return this.annualPlanEndpoint.getDepartments<DepartmentDto[]>(userProfileID);
  }

  getPrioritySubmissionItemTypes() {
    return this.annualPlanEndpoint.getPrioritySubmissionItemTypes<PrioritySubmissionItemTypeVldDto[]>();
  }

  getIndustryPanels() {
    return this.annualPlanEndpoint.getIndustryPanels<IndustryPanelVldDto[]>();
  }

  getSubmissionStatus() {
    return this.annualPlanEndpoint.getSubmissionStatus<SubmissionStatusVldDto[]>();
  }

  getPrioritySubmissionThemes() {
    return this.annualPlanEndpoint.getPrioritySubmissionThemes<PrioritySubmissionThemesVldDto[]>();
  }

  getAnnualPlanYears(userProfileID?: string) {

    return this.annualPlanEndpoint.getAnnualPlanYears<AnnualPlanYearVldDto[]>(userProfileID);
  }

  getAnnualPlanScheduledContinuings(userProfileID?: string) {

    return this.annualPlanEndpoint.getAnnualPlanScheduledContinuings<AnnualPlanScheduledContinuingVldDto[]>(userProfileID);
  }

  getAnnualPlanItemStatus(userProfileID?: string) {

    return this.annualPlanEndpoint.getAnnualPlanItemStatus<AnnualPlanItemStatusVldDto[]>(userProfileID);
  }

  getSessions(userProfileID?: string) {

    return this.annualPlanEndpoint.getSessions<SessionVldDto[]>(userProfileID);
  }

  getAnnualPlanItem(annualPlanItemID?: string, userProfileID?: string) {
    return this.annualPlanEndpoint.getAnnualPlanItem<AnnualPlanItemDto>(annualPlanItemID, userProfileID);
  }

  getAllAnnualPlanItems(userProfileID?: string) {

    return this.annualPlanEndpoint.getAllAnnualPlanItems<AnnualPlanItemDto[]>(userProfileID);
  }

  getAllAnnualPlanItemsByYear(userProfileID?: string, annualPlanYearVldID?: number) {

    return this.annualPlanEndpoint.getAllAnnualPlanItemsByYear<AnnualPlanItemDto[]>(userProfileID, annualPlanYearVldID);
  }

  getAnnualPlanItemsByPrioritySubmission(prioritySubmissionId?: string) {

    return this.annualPlanEndpoint.getAnnualPlanItemsByPrioritySubmission<AnnualPlanItemDto[]>(prioritySubmissionId);
  }

  createPrioritySubmission() {

    return this.annualPlanEndpoint.createPrioritySubmission<PrioritySubmissionDto>();
  }
  
  submitAnnualPlanItem(annualPlanItem: AnnualPlanItemDto) {
    return this.annualPlanEndpoint.submitAnnualPlanItem<BusinessRuleMessage[]>(annualPlanItem);
  }

  submitOrganization(organizationDto: OrganizationDto) {
    return this.annualPlanEndpoint.submitOrganization<BusinessRuleMessage[]>(organizationDto);
  }

  async uploadExternalDocument(externalDocuments: ExternalDocumentDto[]) {
    let response = [];
    const formData = new FormData();
    for (let externalDocument of externalDocuments) {
      if (externalDocument.file != null) {
        formData.append(externalDocument.file.name, externalDocument.file);
      }
    }
    if (formData != null && externalDocuments.length > 0) {
      formData.append('folderkey', externalDocuments[0].annualPlanItemID);
      await this.annualPlanEndpoint.uploadExternalDocument(formData);
    }

    return response;
  }

  downloadFile(externalDocumentID: string, fileName: string) {
    return this.annualPlanEndpoint.downloadFile(externalDocumentID, fileName);
  }
}
